(() => {
  if (window.__KAIJU_SUBSCRIPTION_QTY_LIMIT__) return;
  window.__KAIJU_SUBSCRIPTION_QTY_LIMIT__ = true;

  /*
   * Limite par défaut pour toutes les lignes subscription.
   */
  const DEFAULT_SUBSCRIPTION_MAX_QTY = 2;

  /*
   * Exceptions par produit.
   * Performance Pack reste limité à 1.
   */
  const PRODUCT_MAX_QTY = {
    10448039706961: 1,
  };

  /*
   * AOV cart drawer.
   */
  const AOV_DRAWER_SELECTOR = '#aov-cart-drawer';
  const AOV_SUB_ITEM_SELECTOR =
    '.AOV-CartDrawer__SubscriptionItem';
  const AOV_QTY_WRAPPER_SELECTOR =
    '.AOV-CartDrawer-ItemQuantity';

  /*
   * Dawn / cart drawer Shopify classique.
   */
  const DAWN_DRAWER_SELECTOR =
    'cart-drawer, #CartDrawer';

  const DAWN_ITEM_SELECTOR =
    '#CartDrawer-CartItems .cart-item';

  let syncTimer = null;
  let isSyncing = false;
  let isEnforcing = false;
  let lastCart = null;

  const getMaxForProduct = (productId) => {
    const id = Number(productId);

    return (
      PRODUCT_MAX_QTY[id] ??
      DEFAULT_SUBSCRIPTION_MAX_QTY
    );
  };

  const fetchCart = async () => {
    const root =
      window.Shopify?.routes?.root || '/';

    const response = await fetch(
      `${root}cart.js`,
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to retrieve cart.'
      );
    }

    return response.json();
  };

  const changeCartItem = async (
    item,
    quantity
  ) => {
    const root =
      window.Shopify?.routes?.root || '/';

    const response = await fetch(
      `${root}cart/change.js`,
      {
        method: 'POST',
        credentials: 'same-origin',

        headers: {
          'Content-Type':
            'application/json',

          Accept:
            'application/json',
        },

        body: JSON.stringify({
          /*
           * La key est plus robuste que le numéro
           * de ligne si le panier est réorganisé.
           */
          id: item.key,
          quantity,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to update subscription quantity.'
      );
    }

    return response.json();
  };

  const notifyCartUpdated = (cart) => {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart,
        },
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        detail: {
          cart,
          openDrawer: true,
        },
      })
    );

    window.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart,
        },
      })
    );
  };

  const refreshClassicCartDrawer =
    async (cart, changedItem) => {
      const drawer =
        document.querySelector(
          'cart-drawer'
        );

      if (
        !drawer ||
        typeof drawer.renderContents !==
          'function'
      ) {
        return;
      }

      const configuredSections =
        drawer.getSectionsToRender?.();

      const sectionIds =
        Array.isArray(
          configuredSections
        ) &&
        configuredSections.length
          ? configuredSections
              .map(
                (section) =>
                  section?.id
              )
              .filter(Boolean)
          : [
              'cart-drawer',
              'cart-icon-bubble',
            ];

      const uniqueSectionIds = [
        ...new Set(sectionIds),
      ];

      const sectionsUrl =
        `${window.location.pathname}` +
        `?sections=${encodeURIComponent(
          uniqueSectionIds.join(',')
        )}`;

      const response = await fetch(
        sectionsUrl,
        {
          credentials: 'same-origin',

          headers: {
            Accept:
              'application/json',
          },
        }
      );

      if (!response.ok) return;

      const sections =
        await response.json();

      drawer.renderContents({
        id:
          changedItem?.variant_id ||
          cart?.items?.[0]
            ?.variant_id ||
          0,

        sections,
      });
    };

  const markSubscriptionInput = (
    input,
    plusButton,
    item,
    maxQuantity
  ) => {
    if (!input) return;

    input.dataset.kaijuSubscriptionQty =
      'true';

    input.dataset.kaijuMaxQty =
      String(maxQuantity);

    input.dataset.kaijuProductId =
      String(item?.product_id || '');

    input.dataset.kaijuCartKey =
      String(item?.key || '');

    input.readOnly = true;

    input.setAttribute(
      'inputmode',
      'none'
    );

    input.setAttribute(
      'autocomplete',
      'off'
    );

    input.setAttribute(
      'aria-readonly',
      'true'
    );

    input.setAttribute(
      'min',
      '1'
    );

    input.setAttribute(
      'max',
      String(maxQuantity)
    );

    input.style.userSelect = 'none';

    const currentQuantity =
      Number.parseInt(
        input.value || '1',
        10
      ) || 1;

    /*
     * Correction visuelle immédiate.
     * Le panier Shopify est corrigé séparément.
     */
    if (
      currentQuantity >
      maxQuantity
    ) {
      input.value =
        String(maxQuantity);
    }

    if (!plusButton) return;

    const quantityAfterClamp =
      Math.min(
        currentQuantity,
        maxQuantity
      );

    const isAtMaximum =
      quantityAfterClamp >=
      maxQuantity;

    plusButton.disabled =
      isAtMaximum;

    plusButton.style.opacity =
      isAtMaximum ? '0.4' : '';

    plusButton.style.pointerEvents =
      isAtMaximum ? 'none' : '';

    if (isAtMaximum) {
      plusButton.setAttribute(
        'aria-disabled',
        'true'
      );
    } else {
      plusButton.removeAttribute(
        'aria-disabled'
      );
    }
  };

  const clearSubscriptionInput = (
    input,
    plusButton
  ) => {
    if (
      !input ||
      input.dataset
        .kaijuSubscriptionQty !==
        'true'
    ) {
      return;
    }

    delete input.dataset
      .kaijuSubscriptionQty;

    delete input.dataset
      .kaijuMaxQty;

    delete input.dataset
      .kaijuProductId;

    delete input.dataset
      .kaijuCartKey;

    input.readOnly = false;

    input.removeAttribute(
      'aria-readonly'
    );

    input.removeAttribute('max');

    input.style.userSelect = '';

    if (plusButton) {
      plusButton.disabled = false;
      plusButton.style.opacity = '';
      plusButton.style.pointerEvents =
        '';

      plusButton.removeAttribute(
        'aria-disabled'
      );
    }
  };

  const getPlusButton = (
    wrapper
  ) => {
    if (!wrapper) return null;

    return (
      wrapper.querySelector(
        'button[name="plus"]'
      ) ||
      wrapper.querySelector(
        'button[aria-label*="increase" i]'
      ) ||
      wrapper.querySelector(
        'button:last-of-type'
      )
    );
  };

  /*
   * AOV cart drawer.
   */
  const syncAovCartDrawer = (
    cart
  ) => {
    const drawer =
      document.querySelector(
        AOV_DRAWER_SELECTOR
      );

    if (!drawer) return;

    const subscriptionItems =
      Array.from(
        drawer.querySelectorAll(
          AOV_SUB_ITEM_SELECTOR
        )
      );

    subscriptionItems.forEach(
      (subscriptionItem) => {
        const wrapper =
          subscriptionItem.querySelector(
            AOV_QTY_WRAPPER_SELECTOR
          );

        const input =
          wrapper?.querySelector(
            'input[type="number"]'
          );

        if (!input) return;

        const plusButton =
          getPlusButton(wrapper);

        const productId =
          Number(
            subscriptionItem.dataset
              .productId ||
              subscriptionItem
                .closest(
                  '[data-product-id]'
                )
                ?.getAttribute(
                  'data-product-id'
                ) ||
              0
          );

        /*
         * On récupère la ligne Shopify si possible,
         * sinon le product ID suffit pour appliquer
         * la limite visuelle.
         */
        const matchingItem =
          cart.items.find(
            (item) =>
              item.selling_plan_allocation &&
              Number(
                item.product_id
              ) === productId
          ) || {
            product_id: productId,
          };

        const maxQuantity =
          getMaxForProduct(
            matchingItem.product_id
          );

        markSubscriptionInput(
          input,
          plusButton,
          matchingItem,
          maxQuantity
        );
      }
    );
  };

  const getDawnLineNumber = (
    row,
    input,
    fallbackIndex
  ) => {
    const inputIndex =
      Number(
        input?.dataset?.index || 0
      );

    if (inputIndex > 0) {
      return inputIndex;
    }

    const rowIdMatch =
      String(row?.id || '').match(
        /(\d+)$/
      );

    if (rowIdMatch) {
      return Number(rowIdMatch[1]);
    }

    return fallbackIndex + 1;
  };

  /*
   * Cart drawer Shopify classique / Dawn.
   */
  const syncClassicCartDrawer = (
    cart
  ) => {
    const rows = Array.from(
      document.querySelectorAll(
        DAWN_ITEM_SELECTOR
      )
    );

    if (!rows.length) return;

    rows.forEach(
      (row, rowIndex) => {
        const wrapper =
          row.querySelector(
            'quantity-input'
          ) ||
          row.querySelector(
            '.cart-item__quantity-wrapper'
          );

        const input =
          row.querySelector(
            'input.quantity__input[type="number"]'
          ) ||
          wrapper?.querySelector(
            'input[type="number"]'
          );

        if (!input) return;

        const plusButton =
          getPlusButton(
            wrapper || row
          );

        const lineNumber =
          getDawnLineNumber(
            row,
            input,
            rowIndex
          );

        const item =
          cart.items[
            lineNumber - 1
          ];

        const isSubscription =
          Boolean(
            item?.selling_plan_allocation
          );

        if (!isSubscription) {
          clearSubscriptionInput(
            input,
            plusButton
          );

          return;
        }

        const maxQuantity =
          getMaxForProduct(
            item.product_id
          );

        markSubscriptionInput(
          input,
          plusButton,
          item,
          maxQuantity
        );
      }
    );
  };

  const enforceServerLimits =
    async (cart) => {
      if (isEnforcing) return cart;

      const fixes = cart.items
        .filter((item) => {
          if (
            !item.selling_plan_allocation
          ) {
            return false;
          }

          const maxQuantity =
            getMaxForProduct(
              item.product_id
            );

          return (
            item.quantity >
            maxQuantity
          );
        })
        .map((item) => ({
          item,

          quantity:
            getMaxForProduct(
              item.product_id
            ),
        }));

      if (!fixes.length) {
        return cart;
      }

      isEnforcing = true;

      let changedItem = null;

      try {
        for (const fix of fixes) {
          await changeCartItem(
            fix.item,
            fix.quantity
          );

          changedItem = fix.item;
        }

        const updatedCart =
          await fetchCart();

        lastCart = updatedCart;

        /*
         * Recharge le drawer classique.
         */
        try {
          await refreshClassicCartDrawer(
            updatedCart,
            changedItem
          );
        } catch (error) {
          console.warn(
            '[Kaiju subscription quantity] Classic drawer refresh failed.',
            error
          );
        }

        /*
         * Permet à AOV ou à d’autres scripts
         * de se resynchroniser.
         */
        notifyCartUpdated(
          updatedCart
        );

        return updatedCart;
      } finally {
        isEnforcing = false;
      }
    };

  const syncAll = async () => {
    if (isSyncing) return;

    isSyncing = true;

    try {
      let cart =
        await fetchCart();

      cart =
        await enforceServerLimits(
          cart
        );

      lastCart = cart;

      syncAovCartDrawer(cart);
      syncClassicCartDrawer(cart);
    } catch (error) {
      console.warn(
        '[Kaiju subscription quantity]',
        error
      );
    } finally {
      isSyncing = false;
    }
  };

  const scheduleSync = (
    delay = 120
  ) => {
    window.clearTimeout(
      syncTimer
    );

    syncTimer =
      window.setTimeout(
        syncAll,
        delay
      );
  };

  /*
   * Bloque le bouton "+" avant les handlers
   * AOV ou Dawn.
   */
  document.addEventListener(
    'click',
    (event) => {
      const clickedButton =
        event.target.closest?.(
          'button'
        );

      if (!clickedButton) return;

      const wrapper =
        clickedButton.closest(
          AOV_QTY_WRAPPER_SELECTOR
        ) ||
        clickedButton.closest(
          'quantity-input'
        ) ||
        clickedButton.closest(
          '.cart-item__quantity-wrapper'
        );

      if (!wrapper) return;

      const input =
        wrapper.querySelector(
          'input[data-kaiju-subscription-qty="true"]'
        );

      if (!input) return;

      const plusButton =
        getPlusButton(wrapper);

      const isPlusButton =
        clickedButton ===
          plusButton ||
        plusButton?.contains(
          clickedButton
        );

      if (!isPlusButton) return;

      const maxQuantity =
        Number(
          input.dataset
            .kaijuMaxQty ||
            DEFAULT_SUBSCRIPTION_MAX_QTY
        );

      const currentQuantity =
        Number.parseInt(
          input.value || '1',
          10
        ) || 1;

      if (
        currentQuantity >=
        maxQuantity
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        markSubscriptionInput(
          input,
          plusButton,
          {
            product_id:
              input.dataset
                .kaijuProductId,

            key:
              input.dataset
                .kaijuCartKey,
          },
          maxQuantity
        );

        return;
      }

      /*
       * Laisse le panier passer de 1 à 2,
       * puis resynchronise le bouton.
       */
      scheduleSync(250);
    },
    true
  );

  /*
   * Empêche saisie, collage et molette.
   */
  document.addEventListener(
    'keydown',
    (event) => {
      const input =
        event.target.closest?.(
          'input[data-kaiju-subscription-qty="true"]'
        );

      if (!input) return;

      event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'paste',
    (event) => {
      const input =
        event.target.closest?.(
          'input[data-kaiju-subscription-qty="true"]'
        );

      if (!input) return;

      event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'wheel',
    (event) => {
      const input =
        event.target.closest?.(
          'input[data-kaiju-subscription-qty="true"]'
        );

      if (!input) return;

      event.preventDefault();
    },
    {
      passive: false,
      capture: true,
    }
  );

  document.addEventListener(
    'change',
    (event) => {
      if (
        event.target.matches?.(
          'input[data-kaiju-subscription-qty="true"]'
        )
      ) {
        scheduleSync(200);
      }
    },
    true
  );

  const mutationIsRelevant = (
    mutation
  ) => {
    const target =
      mutation.target;

    if (
      target instanceof Element &&
      target.closest(
        `${AOV_DRAWER_SELECTOR}, ${DAWN_DRAWER_SELECTOR}`
      )
    ) {
      return true;
    }

    return Array.from(
      mutation.addedNodes
    ).some((node) => {
      if (!(node instanceof Element)) {
        return false;
      }

      return (
        node.matches?.(
          `${AOV_DRAWER_SELECTOR}, ${DAWN_DRAWER_SELECTOR}`
        ) ||
        Boolean(
          node.querySelector?.(
            `${AOV_DRAWER_SELECTOR}, ${DAWN_DRAWER_SELECTOR}`
          )
        )
      );
    });
  };

  const observeCartDrawers = () => {
    if (!document.body) return;

    const observer =
      new MutationObserver(
        (mutations) => {
          if (
            mutations.some(
              mutationIsRelevant
            )
          ) {
            scheduleSync();
          }
        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
      }
    );

    scheduleSync(0);
  };

  document.addEventListener(
    'cart:updated',
    () => scheduleSync(50)
  );

  document.addEventListener(
    'cart:refresh',
    () => scheduleSync(100)
  );

  document.addEventListener(
    'shopify:section:load',
    () => scheduleSync(100)
  );

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      observeCartDrawers
    );
  } else {
    observeCartDrawers();
  }
})();